import React from 'react';
import { Users, Loader2 } from "lucide-react";
import { useClubs } from "@/hooks/useClubs";
import { ClubCard } from './ClubCard';
import { EmptyClubState } from './EmptyClubState';

interface Profile {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
}

interface MemberLandingPageProps {
  profile: Profile;
}

export const MemberLandingPage = ({ profile }: MemberLandingPageProps) => {
  const { clubs, loading } = useClubs();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="flex items-center gap-3">
          <Loader2 className="w-6 h-6 animate-spin text-primary" />
          <span className="text-muted-foreground">Loading your clubs...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* Welcome Header */}
      <div className="text-center space-y-2">
        <h1 className="text-3xl font-bold text-foreground">
          Game on, {profile?.first_name}!
        </h1>
        <p className="text-muted-foreground">
          Your journey starts now. Choose your team to unlock your Stats.
        </p>
      </div>

      {clubs.length === 0 ? (
        <EmptyClubState />
      ) : (
        <div className="space-y-8">
          {/* Club Cards Section */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <Users className="w-6 h-6 text-primary" />
              <h2 className="text-xl font-semibold text-foreground">
                Your Clubs
              </h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {clubs.map((club) => (
                <ClubCard
                  key={club.id}
                  club={club}
                />
              ))}
            </div>
          </div>

        </div>
      )}
    </div>
  );
};
